module.exports = __webpack_public_path__ + "img/tv-ad-dtg.343276b3.png";